// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__DMXZ4","normal":"Dropdown_normal__7NmyT","compact":"Dropdown_compact__lUV2U","compactwithlabels":"Dropdown_compactwithlabels__6Qw3t"};